"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Transition_1 = require("./_Transition");
exports._TransitionList = {
    type: "list",
    flattened: true,
    member: {
        shape: _Transition_1._Transition
    }
};
//# sourceMappingURL=_TransitionList.js.map